import { Box, Button, Grid, List, ListItem, ListItemButton, Typography } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'
import { sidebar } from '../services/directory'

const SideBar = () => {
    return (
        <>
            <Box sx={{ bgcolor: '#d9d9d9', width: '100%', overflowX: 'hidden' }} height='100%'>
                <Grid
                    container
                    direction='column'
                    justifyContent='center'
                    alignItems='center'
                    sx={{ p: '10px' }}
                >
                    {
                        Object.keys(sidebar).map((el, id) => (
                            <React.Fragment key={id}>
                                <Typography key={id} variant='body1' sx={{ paddingTop: '10px' }}>{el}</Typography>
                                <List>
                                    {sidebar[el].map((item, index) => (
                                        <ListItem key={index}>
                                            <ListItemButton sx={{ p: '0' }}>
                                                <Button
                                                    variant='contained'
                                                    size='small'
                                                    fontSize='20px'
                                                    sx={{
                                                        whiteSpace: 'nowrap',
                                                        textTransform: 'none',
                                                        color: '#212121',
                                                        bgcolor: '#fafafa',
                                                        fontSize: '12px',
                                                        fontWeight: '550'
                                                    }}
                                                    fullWidth
                                                    LinkComponent={Link}
                                                    to={item.code}
                                                >
                                                    {item.title}
                                                </Button>
                                            </ListItemButton>
                                        </ListItem>
                                    ))}
                                </List>
                            </React.Fragment>
                        ))
                    }
                </Grid>
            </Box>
        </>
    )
}

export default SideBar